import { cibCircle, cilBasket, cilMoney } from '@coreui/icons'
import CIcon from '@coreui/icons-react'
import {
  CAvatar,
  CDropdown,
  CDropdownDivider,
  CDropdownHeader,
  CDropdownItem,
  CDropdownMenu,
  CDropdownToggle,
  CLink,
} from '@coreui/react'
import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import PermissionCheck from 'src/components/auth/permissionCheck'
import { scopes } from 'src/components/auth/permissionsMap'
import { SignOutButton } from 'src/components/layout/SignOutButton'
import { getUserRoles, getUserTenantMemberships, getUserInfo } from '../auth/authorisation'
import ToggleSwitch from './ToggleSwitch'

const tenantOverrides = {
  aiopartners: {
    displayName: 'AIO Partners',
    url: 'https://aiopartners.ivetted.com',
  },
  aldi: {
    displayName: 'Aldi',
    url: 'https://aldi.ivetted.com',
  },
  costco: {
    displayName: 'Costco',
    url: 'https://costco.ivetted.com',
  },
  lidl: {
    displayName: 'Lidl',
    url: 'https://lidl.ivetted.com',
  },
  dev: {
    displayName: 'Dev',
    url: 'https://ivetted-webapp-dev-002-exgae5bzg4epbncf.uksouth-01.azurewebsites.net/',
  },
}

const getTenantKey = (tenantName) => tenantName?.trim().toLowerCase()

const normaliseUrl = (url) => {
  if (!url) return null
  return /^https?:\/\//i.test(url) ? url : `https://${url}`
}

const getDefaultTenantUrl = (tenantName) => {
  return `https://${tenantName}.ivetted.com/`
}

const getTenantDisplayData = (tenantName) => {
  const key = getTenantKey(tenantName)
  const override = tenantOverrides[key] || {}

  return {
    displayName: override.displayName || tenantName,
    url: normaliseUrl(override.url) || getDefaultTenantUrl(tenantName),
  }
}
const AppHeaderDropdown = ({ isUnlimited }) => {
  const [tenants, setTenants] = useState({ set: false, items: [] })
  const [roles, setRoles] = useState([])
  const [user, setUser] = useState({})

  const goToTenant = function (tenantName) {
    const { url } = getTenantDisplayData(tenantName)
    window.location = url
  }

  useEffect(() => {
    if (tenants.set === false) {
      getUserTenantMemberships().then((x) => {
        setTenants(x.filter((x) => x !== 'privateattestations'))
      })
    }
    setRoles(getUserRoles())
    getUserInfo().then((x) => setUser(x))
  }, [])

  return (
    <CDropdown variant="nav-item">
      <CDropdownToggle placement="bottom-end" className="py-0" caret={false}>
        <CAvatar
          src={
            'data:image/jpeg;base64,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'
          }
          size="sm"
        />
      </CDropdownToggle>

      <CDropdownMenu className="pt-0" placement="bottom-end">
        <CDropdownHeader className="fw-semibold py-2">Account</CDropdownHeader>
        <CDropdownItem disabled className="text-dark">
          {user?.fullName}
        </CDropdownItem>
        <CDropdownDivider />
        {!isUnlimited && (
          <>
            <PermissionCheck errorProps={{ disabled: true }} scopes={[scopes.credits.purchase]}>
              <CDropdownHeader className="fw-semibold py-2">Credits</CDropdownHeader>
              <CDropdownItem href="/app/credits">
                <CLink href="/app/credits" className="text-decoration-none text-dark">
                  <CIcon icon={cilMoney} href="/app/credits" className="me-2" />
                  Buy credits
                </CLink>
              </CDropdownItem>
              <CDropdownItem>
                <CLink href="/app/orders" className="text-decoration-none text-dark">
                  <CIcon icon={cilBasket} href="/app/orders" className="me-2" />
                  Orders
                </CLink>
              </CDropdownItem>
              {/* <CDropdownItem>
          <CLink href="#" className="text-decoration-none text-dark">
            <CIcon icon={cilLockLocked} href="/app/orders" className="me-2" />
            Change password (soon)
          </CLink>
        </CDropdownItem> */}
              <CDropdownDivider />
            </PermissionCheck>
          </>
        )}
        {tenants.length > 0 && (
          <>
            <CDropdownHeader className="fw-semibold py-2">iVetted Sites</CDropdownHeader>

            {Array.isArray(tenants) &&
              tenants.map((tenant) => {
                const { displayName } = getTenantDisplayData(tenant)

                return (
                  <CDropdownItem key={tenant} onClick={() => goToTenant(tenant)}>
                    <CIcon icon={cibCircle} className="me-2" />
                    {displayName}
                  </CDropdownItem>
                )
              })}
            <CDropdownDivider />
          </>
        )}
        <CDropdownItem>
          {/* <CIcon icon={cilMoney} size="lg" /> */}
          Dark mode
          <ToggleSwitch className="d-inline" />
        </CDropdownItem>
        <CDropdownDivider />
        <CDropdownItem>
          <div className="d-grid gap-2">
            <SignOutButton />
          </div>
        </CDropdownItem>
      </CDropdownMenu>
    </CDropdown>
  )
}

export default AppHeaderDropdown

AppHeaderDropdown.propTypes = {
  isUnlimited: PropTypes.bool,
}
